import { GovLayout, GovLayoutColumn } from '@gov-design-system-ce/react';
import { useCmsFaqCategoriesQuery } from '@gov-nx/api';
import { useLanguageNamespaceLoader, useLocale } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { Breadcrumbs, LayoutGap } from '@gov-nx/ui/web';
import { CmsFaqTabs } from '../../Cms/CmsFaqTabs';

export interface FaqViewProps {
	code: PageCode;
}

export const FaqView = ({ code }: FaqViewProps) => {
	const cmsFaqCategories = useCmsFaqCategoriesQuery();
	const { t } = useLocale(code);
	const translations = useLanguageNamespaceLoader(code);
	if (translations.isLoading) return null;

	return (
		<LayoutGap gap="l">
			<Breadcrumbs
				options={[
					{ label: t('domu'), toPage: 'dashboard' },
					{ label: t('casto-se-ptate') },
				]}
			/>
			<h1 className="mb-(--templates-margin-m)!">{t('casto-se-ptate')}</h1>
			<GovLayout
				type="text"
				variant="left">
				<GovLayoutColumn>
					<CmsFaqTabs
						faqCategories={cmsFaqCategories.data}
						isLoading={cmsFaqCategories.isLoading}
						tabsType="text"
					/>
				</GovLayoutColumn>
			</GovLayout>
		</LayoutGap>
	);
};
